// src/hooks/useDateActivityInfo.js
import {useQuery} from 'react-query';
import {fetchDateActivityBanner, fetchDateActivityInfo} from "../api/dateActivityInfoApi";

export const useDateActivityInfo = () => {
    return useQuery(['dateActivityInfo'], () => fetchDateActivityInfo(), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};

export const useDateActivityBanner = (pageNumber, pageSize) => {
    return useQuery(['dateActivityBanner', pageNumber, pageSize], () => fetchDateActivityBanner(pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
